import { Pipe, PipeTransform } from '@angular/core';
import { HomeUrlHelper } from '@sc/pas-common';

@Pipe({
    name: 'scSideBarLink',
    pure: false
})
export class SideBarLinkPipe implements PipeTransform {
    constructor(public urlHelper: HomeUrlHelper) {

    }
    transform(link: string, origin = ''): string {
        return this.urlHelper.urlByOrigin(link, origin);
    }
}
